import { fetchLocale, fetchModuleLocale } from "ducks/actions/index";
import {
  IN_APP_PURCHASE,
  MARKETING_WEB_NAVIGATION,
  PAYMENT_MODULE_LOCALE_KEYS,
  paths
} from "./constants";
import { getItem } from "./localStorage";
import { isAddingEasyPaisa, isMarketingWebNavigation } from "./helpers";

export const invokeLocale = (dispatch, callback) => {
  const currentPath = window.location.pathname
  const isMarketingWeb = isMarketingWebNavigation()
  
  if (
    (currentPath ===
      paths.PAYMENT_CARD.replace(":channel", "web") &&
      getItem(IN_APP_PURCHASE)) ||
    isAddingEasyPaisa() || (isMarketingWeb)
  ) {
    const moduleList = isMarketingWeb ? MARKETING_WEB_NAVIGATION : PAYMENT_MODULE_LOCALE_KEYS
    dispatch(fetchModuleLocale(moduleList.join(","), callback));
  } else {
    dispatch(fetchLocale(callback));
  }
};
